import { render, staticRenderFns } from "./SnippetLivePreview.vue?vue&type=template&id=4710de30&scoped=true"
import script from "./SnippetLivePreview.vue?vue&type=script&lang=js"
export * from "./SnippetLivePreview.vue?vue&type=script&lang=js"
import style0 from "./SnippetLivePreview.vue?vue&type=style&index=0&id=4710de30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4710de30",
  null
  
)

export default component.exports